import * as React from "react";
import { useFormikContext } from "formik";
import { naturalSortIgnoreCase } from "util/SortUtils";
import { isProcessorEnabled } from "components/configurations/helpers";
const toggleProcessorStatus = (className, enabled, values) => {
  const disabledProcessors = values.disabled_processors;
  return enabled ? [...disabledProcessors, className] : disabledProcessors.filter((processorName) => processorName !== className);
};
const MessageProcessorStatusFormGroup = () => {
  const { values: formValues, setFieldValue } = useFormikContext();
  const sortedProcessorOrder = [...formValues.processor_order].sort((a, b) => naturalSortIgnoreCase(a.name, b.name));
  return sortedProcessorOrder.map((processor) => {
    const enabled = isProcessorEnabled(processor, formValues);
    return /* @__PURE__ */ React.createElement("tr", { key: processor.name }, /* @__PURE__ */ React.createElement("td", null, processor.name), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "checkbox",
        checked: enabled,
        onChange: () => setFieldValue("disabled_processors", toggleProcessorStatus(processor.class_name, enabled, formValues))
      }
    )));
  });
};
export default MessageProcessorStatusFormGroup;
